import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga4';

import store, { stateInitializer } from '../../store';

import EmbedOverlayLocator from './EmbedOverlayLocator';

export default class EmbedOverlay extends Component {
  constructor(props) {
    super(props);

    const { categoryRestriction, googleAnalyticsId, showFilters } = props;
    const defaultCategories = categoryRestriction?.length ? [categoryRestriction] : []

    stateInitializer({
      locator: {
        ...props,
        isFetching: true,
        location: this.props.specificLocation,
        locations: [],
        markers: [],
        popups: [],
        selectedCategories: defaultCategories,
        showRefreshList: false,
        showFilters
      },
      embed: {
        pageEmbed: props.pageEmbed,
        responsiveMobileHeight: props.responsiveMobileHeight,
        showing: false,
        showingMobileList: false,
      },
    });

    if (googleAnalyticsId) {
      ReactGA.initialize(googleAnalyticsId);
      ReactGA.send({ hitType: 'pageview', page: '/closeby/locations', title: 'View Locations' });
    }
  }

  render() {
    const { defaultViewport, doesMapGeolocate, mapboxClientKey } = this.props;

    return (
      <Provider store={store}>
        <EmbedOverlayLocator
          mapboxClientKey={mapboxClientKey}
          doesMapGeolocate={doesMapGeolocate}
          defaultViewport={defaultViewport}
        />
      </Provider>
    );
  }
}

EmbedOverlay.propTypes = {
  buttonSetting: PropTypes.string.isRequired,
  buttonStyle: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  hideAddress: PropTypes.bool.isRequired,
  hideLocationCategories: PropTypes.bool.isRequired,
  hoursDisplay: PropTypes.string,
  hoursFormat: PropTypes.string.isRequired,
  scrollZoomEnabled: PropTypes.bool.isRequired,
  showFullscreen: PropTypes.bool.isRequired,
  showFilters: PropTypes.bool.isRequired,
  style: PropTypes.string.isRequired,
  suggestionCountries: PropTypes.array.isRequired,
  suggestionType: PropTypes.string.isRequired,
  listStyle: PropTypes.string.isRequired,
  mapKey: PropTypes.string.isRequired,
  mapboxClientKey: PropTypes.string.isRequired,
  markerStyle: PropTypes.string.isRequired,
  mobileStyle: PropTypes.string.isRequired,
  pageEmbed: PropTypes.bool,
  defaultPosition: PropTypes.string.isRequired,
  defaultViewport: PropTypes.object,
  categoryRestriction: PropTypes.string,
  googleAnalyticsId: PropTypes.string,
  doesMapGeolocate: PropTypes.bool.isRequired,
  enableLocationCluster: PropTypes.bool.isRequired,
  responsiveMobileHeight: PropTypes.bool.isRequired,
}
